import { TotalDataType } from 'app/components/CommonStyled/Total/interfaces';
import { TotalWrapper } from 'app/components/CommonStyled/Total/styled';
import { PEOPLE_CONTEXT } from 'store/reducers/people/people-reducer';
import styled from 'styled-components';

const dataTypeToBackground = new Map<TotalDataType | string, string>([
  [TotalDataType.SKILLS, 'rgba(235, 130, 61, 0.1)'],
  ['skills', 'rgba(235, 130, 61, 0.1)'],
  [TotalDataType.INDUSTRIES, 'rgba(141, 167, 108, 0.1)'],
  [TotalDataType.PRIOR_CLIENTS, 'rgba(16, 77, 91, 0.1)'],
  [TotalDataType.CLIENTS, 'rgba(16, 77, 91, 0.1)'],
  [TotalDataType.PROJECTS, 'rgba(57, 43, 98, 0.1)'],
  [TotalDataType.PASSIONS, 'rgba(212, 117, 99, 0.1)'],
  [TotalDataType.COMPANIES, 'rgba(84, 120, 161, 0.1)'],
  [TotalDataType.COMMUNITIES, 'rgba(162, 101, 101, 0.1)'],
  [TotalDataType.CONVENINGS, 'rgba(162, 101, 101, 0.1)'],
  [TotalDataType.LANGUAGES, 'rgba(255, 194, 41, 0.1)'],
  [TotalDataType.COUNTRIES, 'rgba(255, 194, 41, 0.1)'],
  [TotalDataType.CITIES, 'rgba(255, 194, 41, 0.1)'],
]);

export const CollectiveDirectoryPersonDrawerSearchMatchesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  padding: 24px;

  border-radius: 8px;
  background: ${({ theme }) =>
    theme.context === PEOPLE_CONTEXT.COLLECTIVE_DIRECTORY
      ? `var(--color-data-people-background-secondary)`
      : `rgba(183, 205, 247, 0.1)`};

  ${TotalWrapper} {
    height: 82px;
    padding-top: 7px;
    cursor: pointer;
  }

  position: relative;
`;

export const CollectiveDirectoryPersonDrawerSearchMatchesTitle = styled.h5`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  text-align: center;

  color: var(--color-text);
`;

interface CollectiveDirectoryPersonDrawerSearchMatchesSparkleContainerProps {
  top?: string;
  left?: string;
  bottom?: string;
  right?: string;
}

export const CollectiveDirectoryPersonDrawerSearchMatchesSparkleContainer = styled.div<CollectiveDirectoryPersonDrawerSearchMatchesSparkleContainerProps>`
  position: absolute;

  ${({ top = 'unset', right = 'unset', bottom = 'unset', left = 'unset' }) => `
    top: ${top};
    right: ${right};
    bottom: ${bottom};
    left: ${left};
  `}
`;

export const CollectiveDirectoryPersonDrawerSearchMatchesTotalsWrapper = styled.div`
  display: flex;
  flex-direction: column;

  & > :first-child {
    margin-bottom: 18px;
  }
`;

export const CollectiveDirectoryPersonDrawerSearchMatchesTotalsPillsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0.8;
      transform: translateY(-5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const CollectiveDirectoryPersonDrawerSearchMatchesTotalsPillsViewMore = styled.span`
  font-weight: 700;
  font-size: 14px;
  line-height: normal;
  color: rgba(23, 28, 51, 0.5);
  backdrop-filter: blur(2px);
  cursor: pointer;
  padding: 3px 8px;
  border-radius: 20px;
  background: rgba(23, 28, 51, 0.1);
  transition: all 0.2s ease-in-out;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;

  &:hover {
    background: rgba(23, 28, 51, 0.5);
    color: var(--color-text);
  }
`;

export const CollectiveDirectoryPersonDrawerSearchMatchesTotalsPillsWrapper = styled.div<{
  expanded: boolean;
}>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  max-height: ${({ expanded }) => (expanded ? '1000px' : '120px')};
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;

  & *:not(${CollectiveDirectoryPersonDrawerSearchMatchesTotalsPillsViewMore}) {
    cursor: default !important;
  }
`;

export const CollectiveDirectoryPersonDrawerSearchMatchesTotalsTitle = styled.h6`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  text-align: center;
  color: rgba(23, 28, 51, 0.5);
`;

export const CollectiveDirectoryPersonDrawerSearchMatchesTotalsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  gap: 15px;

  ${TotalWrapper} {
    cursor: pointer;
  }
`;

export const CollectiveDirectoryPersonDrawerSearchMatchesTotalsItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  cursor: pointer;
`;

export const CollectiveDirectoryPersonDrawerSearchMatchesTotalsItemIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

interface CollectiveDirectoryPersonDrawerSearchMatchesTotalsItemTitleProps {
  currentlySelected: boolean;
}

export const CollectiveDirectoryPersonDrawerSearchMatchesTotalsItemTitle = styled.h6<CollectiveDirectoryPersonDrawerSearchMatchesTotalsItemTitleProps>`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  color: ${({ currentlySelected }) =>
    currentlySelected ? 'var(--color-text)' : 'rgba(23, 28, 51, 0.5)'};
`;

//SCORE
export const CollectiveDirectoryPersonDrawerSearchMatchScoreWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
`;

export const CollectiveDirectoryPersonDrawerSearchMatchScoreContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  padding: 8px 18px;

  border-radius: 4px;
  background: ${({ theme }) => {
    const matchesPercentage = theme.matchesPercentage;
    if (matchesPercentage === 0)
      return theme.context === PEOPLE_CONTEXT.TEAMING ? '#B8CBF7' : 'rgba(255, 163, 102, 0.10)';
    if (matchesPercentage < 29)
      return theme.context === PEOPLE_CONTEXT.TEAMING ? '#B8CBF7' : 'rgba(255, 163, 102, 0.20)';
    if (matchesPercentage < 49)
      return theme.context === PEOPLE_CONTEXT.TEAMING ? '#B8CBF7' : 'rgba(255, 163, 102, 0.30)';
    if (matchesPercentage < 69)
      return theme.context === PEOPLE_CONTEXT.TEAMING ? '#B8CBF7' : 'rgba(255, 163, 102, 0.40)';
    if (matchesPercentage < 89)
      return theme.context === PEOPLE_CONTEXT.TEAMING ? '#B8CBF7' : 'rgba(255, 163, 102, 0.75)';

    return theme.context === PEOPLE_CONTEXT.TEAMING ? '#B8CBF7' : 'rgba(255, 163, 102, 1)';
  }};
`;

export const CollectiveDirectoryPersonDrawerSearchMatchScore = styled.span`
  font-weight: 700;
  font-size: 14px;
  line-height: normal;

  color: ${({ theme }) => {
    const matchesPercentage = theme.matchesPercentage;

    if (matchesPercentage < 69)
      return theme.context === PEOPLE_CONTEXT.TEAMING
        ? '#ffffff'
        : 'var(--color-data-skill-foreground)';

    return '#ffffff';
  }};

  opacity: ${({ theme }) => (theme.matchesPercentage === 0 ? '0.5' : '1')};
`;

export const CollectiveDirectoryPersonDrawerSearchMatchScoreText = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;

  color: ${({ theme }) => {
    const matchesPercentage = theme.matchesPercentage;

    if (matchesPercentage < 69)
      return theme.context === PEOPLE_CONTEXT.TEAMING
        ? '#ffffff'
        : 'var(--color-data-skill-foreground)';

    return '#ffffff';
  }};

  opacity: 0.5;
`;

export const CollectiveDirectoryPersonDrawerSearchMatchesTeamingExperienceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px 0px;

  [data-type='${({ theme }) => theme.currentlySelected}'] {
    padding: 7px 18px;
    border-radius: 8px;
    background: ${({ theme }) => dataTypeToBackground.get(theme.currentlySelected)};
  }
`;

//COMMON GROUND
export const CollectiveDirectoryPersonDrawerSearchMatchesCommonGroundWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;

  [data-type='${({ theme }) => theme.currentlySelected}'] {
    padding: 7px 18px;
    border-radius: 8px;
    background: ${({ theme }) => dataTypeToBackground.get(theme.currentlySelected)};
  }
`;

export const CollectiveDirectoryPersonDrawerSearchMatchesCommonGroundAvatarsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

// SEARCH CONNECTIONS
export const CollectiveDirectoryPersonDrawerSearchConnectionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding-top: 15px;
  padding-bottom: 10px;
`;

export const CollectiveDirectoryPersonDrawerSearchConnectionsTitle = styled.h6`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  text-align: left;
  display: flex;
  justify-content: space-between;
  color: var(--color-text);
  span {
    color: rgba(23, 28, 51, 0.5);
  }
`;

export const CollectiveDirectoryPersonDrawerSearchConnectionsPulseWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 0px 20px 16px 20px;
`;

export const CollectiveDirectoryPersonDrawerSearchConnectionsPulseContainer = styled.div`
  width: 100%;

  display: flex;
  align-items: flex-start;

  padding: 8px 15px;

  border-radius: 8px;
  background: #003b49;
`;

export const CollectiveDirectoryPersonDrawerSearchConnectionsPulseDescription = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;

  color: #fff;
`;

export const CollectiveDirectoryPersonDrawerSearchConnectionsKeywordContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 4px;

  & > svg {
    min-width: 15px;
    min-height: 15px;

    transform: translateY(2px);
  }
`;

export const CollectiveDirectoryPersonDrawerSearchConnectionsKeywordTitle = styled.h6`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;

  color: var(--color-primary);
`;

export const CollectiveDirectoryPersonDrawerSearchConnectionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
`;

export const CollectiveDirectoryPersonDrawerSearchConnectionsSeparator = styled.hr`
  margin: 0;
  padding: 0;
  border: none;
  height: 1px;
  background: rgba(23, 28, 51, 0.1);
  width: calc(100% - 50px);
  margin-left: 25px;
`;

export const CollectiveDirectoryPersonDrawerSearchConnectionsRow = styled.div`
  grid-column: span 2;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: flex-start;
  gap: 16px;
`;

export const CollectiveDirectoryPersonDrawerSearchConnectionsColumn = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 6px;
`;

export const CollectiveDirectoryPersonDrawerSearchConnectionsRowShowMore = styled.span`
  font-weight: 500;
  font-size: 14px;
  text-align: center;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;

  color: var(--color-text);

  cursor: pointer;
`;

export const CollectiveDirectoryPersonDrawerSearchConnectionsColumnShowMore = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 6px;

  padding: 2px 8px;

  border-radius: 26px;
  background: #ebebeb;

  cursor: pointer;
`;

export const CollectiveDirectoryPersonDrawerSearchConnectionsColumnShowMoreText = styled.h6`
  font-weight: 700;
  font-size: 14px;
  line-height: normal;

  color: rgba(23, 28, 51, 0.5);
`;

export const CollectiveDirectoryPersonDrawerSearchConnectionsColumnTitle = styled.h6`
  font-weight: 500;
  font-size: 12px;
  line-height: normal;
  letter-spacing: 1.2px;
  text-transform: uppercase;

  color: rgba(23, 28, 51, 0.3);
`;

export const CollectiveDirectoryPersonDrawerSearchConnectionsKeywordTitleMatch = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;

  padding: 2px 8px;

  border-radius: 26px;
  background: rgba(141, 167, 108, 0.3);
`;

export const CollectiveDirectoryPersonDrawerSearchConnectionsKeywordTitleMatchText = styled.h6`
  font-weight: 700;
  font-size: 14px;
  line-height: normal;

  color: var(--color-data-industry-foreground);
`;

export const CollectiveDirectoryPersonDrawerSearchConnectionsKeywordTitleNoMatch = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;

  padding: 2px 8px;

  border-radius: 26px;
  background: rgba(23, 28, 51, 0.3);
`;

export const CollectiveDirectoryPersonDrawerSearchConnectionsKeywordTitleNoMatchText = styled.h6`
  font-weight: 700;
  font-size: 14px;
  line-height: normal;

  color: rgba(23, 28, 51, 0.3);
`;

export const CollectiveDirectoryPersonDrawerSearchConnectionBreakdownContainer = styled.div`
  display: grid;
  flex-direction: row;
  align-items: center;
  width: 100%;
  grid-column: 1 / -1;
  gap: 10px;
`;

export const CollectiveDirectoryPersonDrawerSearchConnectionBreakdownItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const CollectiveDirectoryPersonDrawerSearchConnectionBreakdownItemIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

export const CollectiveDirectoryPersonDrawerSearchConnectionBreakdownItemDescription = styled.div`
  font-size: 14px;
  line-height: 16px;
  color: rgba(23, 28, 51, 0.5);
`;
